<template>
    <div :class="{tableWrapper : isRoot}">
        <table>
            <tbody>
                <tr v-for="item in items">
                    <td class="tdTop">
                        <b-form-input class="inputText" v-show="!item.isFolder && item.selectorDcx != null" v-model="item.selectorDcx" size="sm"></b-form-input>
                    </td>
                    <td>
                        <b-button :class="[{btn: !item.selectorDcx == null}, {btnPressed: item.selectorDcx != null}]" squared v-show="!item.isFolder && item.selected == true" @click.stop="toggleSelector(item)" size="sm">
                            <font-awesome-icon class="arboElement btnIcon" :icon="getBtnIcon(item)" size="sm" />
                        </b-button>
                    </td>
                    <td class="tdTop">
                        <b-form-checkbox class="checkBox" v-model="item.selected" @input.self="check(item)" switch button-variant="success"></b-form-checkbox>
                    </td>
                    <td class="tdTop">
                        <span class="text" @click.stop="toggleOpen(item)">{{item.title}}</span>
                    </td>
                    <td class="tdTop">
                        <b-button-group class="btnGroup">
                            <b-button :class="[{btn: !item.visible}, {btnPressed: item.visible}, 'btnGrouped']" squared @click.stop="toggleVisible(item)" size="sm">
                                <font-awesome-icon class="btnIcon" :icon="getVisibleIcon(item)" size="sm" />
                            </b-button>
                            <b-button :class="[{btn: !item.isOpen}, {btnPressed: item.isOpen}, 'btnGrouped']" squared @click.stop="toggleOpen(item)" v-show="item.isFolder" size="sm">
                                <font-awesome-icon class="btnIcon" v-show="item.isFolder" :icon="getCaretIcon(item)" size="sm" />
                            </b-button>
                        </b-button-group>
                    </td>
                    <td>
                        <tree-view-item v-if="item.sublayers" :items="item.sublayers" v-show="item.isOpen" :isRoot="false"></tree-view-item>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts">
    import { Prop, Vue, Watch } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';
    import Component from 'vue-class-component';
    import arcgisLayer from '@/types/map/type-arcgis-layer';

    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faCaretRight, faCaretDown, faPlus, faMinus, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    library.add(faCaretRight, faCaretDown, faPlus, faMinus, faEye, faEyeSlash);

    const CartoModule = namespace("CartoMod");

    @Component({
        name: 'tree-view-item',
        components: {
            FontAwesomeIcon
        }
    })

    export default class TreeViewItem extends Vue {
        @Prop()
        private items!: arcgisLayer[]
        @Prop({ default: true })
        private isRoot!: boolean;
        @CartoModule.Getter
        getArcgisLayers!: arcgisLayer[];

        test(item: any) {
            console.log(this.items)
        }

        toggleOpen(item: arcgisLayer) {
            if (item.isFolder) {
                item.isOpen = !item.isOpen
            }
        }

        toggleSelector(item: arcgisLayer) {
            if (item.selectorDcx == null) {
                item.selectorDcx = '';
            }
            else {
                item.selectorDcx = null;
            }
        }
        toggleVisible(item: arcgisLayer) {
            item.visible = !item.visible;
        }

        getCaretIcon(item: arcgisLayer) {
            if (item.isOpen) {
                return ['fa', 'caret-down']
            }
            else {
                return ['fa', 'caret-right']
            }
        }
        getBtnIcon(item: arcgisLayer) {
            if (item.selectorDcx == null) {
                return ['fa', 'plus']
            }
            else {
                return ['fa', 'minus']
            }
        }
        getVisibleIcon(item: arcgisLayer) {
            if (item.visible == true) {
                return ['fa', 'eye']
            }
            else {
                return ['fa', 'eye-slash']
            }
        }

        check(item) {
            if (item.selected == false) {
                item.selectorDcx = null;
            }
            this.cascadeCheck(item)
            console.log(this.items)
        }

        cascadeCheck(item: arcgisLayer) {
            if (item.isFolder === true) {
                item.sublayers.forEach((sublayer) => {
                    sublayer.selected = item.selected
                })
            }
        }
    }
</script>

<style scoped>

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
        border-color: var(--primary) !important;
        background-color: var(--primary) !important;
    }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--primary) !important;
        border-color: var(--primary) !important;
    }   

    .tableWrapper {
        max-height: 400px;
        overflow-y: scroll;
    }

    .btn {
        display: flex;
        background-color: #93c01f !important;
        border: none;
        padding: 0;
        height: 20px;
        width: 20px;
        margin: 0px 5px;
    }

        .btn:hover {
            transform: scale(1) !important;
        }
        .btn:focus {
            box-shadow : none !important;
        }

    .btnPressed {
        background-color: #7B9C23 !important;
    }

    .btnGroup {
        margin: 0px 5px;
    }

    .btnGrouped {
        margin: 0;
    }

    .btnIcon {
        color: white;
        margin: auto;
    }
    .inputText {
        border-radius: 0;
        margin: 0px 5px;
        height : 10%;
    }

    .text {
        line-height : 25px;
    }

    .tdTop {
        vertical-align: top;
    }

    .icon {
        margin: 0px 5px;
    }

    .checkBox {
        margin : auto;
    }

    table tr td {
        line-height : 1.5 !important;
    }

    tr:nth-child(even) {
        background-color: rgba(255, 255, 255, 0.50);
    }
    tr:nth-child(odd) {
        background-color: rgba(229, 229, 229, 0.50);
    }
</style>

<style>
    .checkBox .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #93c01f !important;
        background-color: #93c01f !important;
    }
</style>